// @ts-nocheck


import React from 'react';


import { vehiclePlanApi } from './../../lib/api';

import { vehiclePlanInfoString } from './../../lib/helpers';
import AutocompleteSelect from './AutocompleteSelect';



export default ({ filter = {}, ...selectProps }) => {
  return (
    <AutocompleteSelect
      fetch={async (params) => {
        return await vehiclePlanApi.fetch({
          ...params,
          ...filter
        });
      }}
      refetchParams={{ filter }}
      fetchSingle={vehiclePlanApi.get}
      notFoundText="Бюджеты не найдены"
      placeholder="Выберите бюджет"
      renderOption={(vehiclePlan, Option) =>
      <Option
        key={vehiclePlan.id}
        value={vehiclePlan.id}
        vehiclePlan={vehiclePlan}>

          {vehiclePlanInfoString(vehiclePlan)}
        </Option>
      }
      {...selectProps} />);


};
